// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DribbbleSquareFilledSvg from "@ant-design/icons-svg/es/asn/DribbbleSquareFilled";
import AntdIcon from '../components/AntdIcon';

var DribbbleSquareFilled = function DribbbleSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleSquareFilledSvg
  }));
};

DribbbleSquareFilled.displayName = 'DribbbleSquareFilled';
export default React.forwardRef(DribbbleSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DribbbleSquareFilled.js
// module id = 993
// module chunks = 0